export default __webpack_public_path__ + "4eb80358cf5272f0f699cf0cec15f1cf.png";